const $quantityBlocks = $('.quantity');

if($quantityBlocks.length) {
    $quantityBlocks.each(function() {
        const $this = $(this),
            $input = $this.find('input[type="number"]');

        let min = 1,
            max = -1;

        if($input.length) {
            // Add quantity increase/decrease buttons
            $('<div class="quantity-nav"><div class="quantity-button quantity-up"></div><div class="quantity-button quantity-down"></div></div>').insertAfter($input);

            // Get quantity increase/decrease buttons
            const $btnUp = $this.find('.quantity-up'),
            $btnDown = $this.find('.quantity-down');

            const updateMinMaxQuantity = (variation = null) => {
                min = parseInt($input.attr('min'), 10) || 1;
                max = parseInt($input.attr('max'), 10) || 999;

                if(isNaN(min)) min = 1;
                if(isNaN(max)) max = -1;
                if(variation?.is_sold_individually === 'yes') max = 1;
            };
            const updateQuantityButtons = () => {
                const enabledCss = {'cursor': 'pointer', 'opacity': 1};
                const disabledCss = {'cursor': 'default', 'opacity': 0.3};
                const value = parseInt($input.val(), 10);
                
                if(value - 1 >= min) {
                    $btnDown.css(enabledCss);
                }
                else {
                    $btnDown.css(disabledCss);
                }

                if(max > -1 && value + 1 <= max) {
                    $btnUp.css(enabledCss);    
                }
                else {
                    $btnUp.css(disabledCss);
                }
            };

            $btnUp.on('click', function() {
                var oldValue = parseFloat($input.val());
                
                if(oldValue < max) {
                    $input.val(oldValue + 1);
                    $input.trigger("change");

                    updateQuantityButtons();
                }
            });
            $btnDown.on('click', function() {
                var oldValue = parseFloat($input.val());
                
                if(oldValue > min) {
                    $input.val(oldValue - 1);
                    $input.trigger("change");

                    updateQuantityButtons();
                }
            });
            
            // Fired when the user selects all the required dropdowns / attributes
            // and a final variation is selected / shown
            $(".single_variation_wrap").on("show_variation", function(event, variation) {
                if(variation) {
                    updateMinMaxQuantity(variation);
                    updateQuantityButtons();
                }
            });

            updateMinMaxQuantity();
            updateQuantityButtons();
        }
    });
}